var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"role":"button"},on:{"click":_setup.getKakaoToken}},[_vm._t("default",function(){return [_c(_setup.SnsLogoCircle,{attrs:{"sns-name":"kakao","width":60,"height":60}})]}),_c('span',{staticClass:"a11y-hidden"},[_vm._v("카카오로 로그인")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }